'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = {
  width: 40,
  lineHeight: 4,
  lineSpacing: 6,
  color: '#000',
  borderRadius: 0,
  active: false,
  padding: '15px'
};
module.exports = exports['default'];